// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1___c89f24d3a83ad9894ab","cls2":"Cta-cls2__d51b34993c905f86de5c Cta-cls1___c89f24d3a83ad9894ab"};